<div class="wrapper">
    <div class="tabs">
        <div class="tabs__outer">
            <div class="tabs__inner">
                @for (tab of tabs; track tab) {
                <div
                    class="tab"
                    [ngClass]="{
                        'tab--active': tab.type === activeTool?.type,
                        'tab--hidden': tab.type === 'floating_svg'
                    }"
                    (click)="activateByType(tab.type)"
                >
                    {{ tab.label }}
                    <span class="close" (click)="closeByType(tab.type)">
                        <i class="fas fa-times"></i>
                    </span>
                </div>
                }
            </div>
        </div>
    </div>

    @if (activeTool) {
    <div class="settings">
        <ng-template [cdkPortalOutlet]="activeTool.settings"></ng-template>
        <app-tool-setting label="Transparant">
            <app-toggle
                [showLabel]="true"
                [(enabled)]="transparencyEnabled"
                (enabledChange)="onToggleTransparency()"
            ></app-toggle>
        </app-tool-setting>
        @if (!activeTool.tool.settingsInstanceOnly &&
        !activeTool.tool.hideAddButton) {
        <app-tool-setting label="Toevoegen">
            <app-button (click)="addByType(activeTool)" class="icon">
                <i class="fas fa-plus"></i>
            </app-button>
        </app-tool-setting>
        }
    </div>
    }

    <app-button class="back" (click)="openToolbox()">
        <i class="fas fa-arrow-left"></i>
        <span i18n>Terug</span>
    </app-button>
</div>
